import { InvestorsContext } from "../context/investorContext"
import { useContext } from "react"

export const useInvestorsContext = () => {
  const context = useContext(InvestorsContext)

  if(!context) {
    throw Error('useInvestorContext must be used inside a InvestorContextProvider')
  }

  return context
}